const { BASE_PARAMS } = require('./constants');

const createBaseEvent = (params) => ({
    ...BASE_PARAMS,
    ...params
});

module.exports = {
    createBaseEvent
};
